import { NewCable, middle, getJack, validateJackPair, Cable, nextId, LoadingState, Model, ScopeState, Message } from "./Model.js";
import { change as change_2, filter, fold, remove, tryFind, empty, add, map } from "./.fable/fable-library.3.1.16/Map.js";
import { midi, control, disconnect, connect, build, initScope, mapScope as mapScope_1 } from "./Mod.js";
import { tick, fixCanvas } from "./Scope.js";
import { Cmd_ofSub, Cmd_batch, Cmd_none, Cmd_OfFunc_perform } from "./.fable/Fable.Elmish.3.1.0/cmd.fs.js";
import { equalArrays, uncurry, compare, partialApply } from "./.fable/fable-library.3.1.16/Util.js";
import { MIDIOption, requestMIDIAccess } from "./WebMIDI.js";
import { ofArray, reverse, map as map_1, tail, head, isEmpty, cons, empty as empty_1, length, singleton } from "./.fable/fable-library.3.1.16/List.js";
import { iterate } from "./.fable/fable-library.3.1.16/Seq.js";
import { saveCmd, loadCmd } from "./Storage.js";
import { defaultArg, bind, map as map_2 } from "./.fable/fable-library.3.1.16/Option.js";
import { append } from "./.fable/fable-library.3.1.16/Array.js";
import { printf, toConsole } from "./.fable/fable-library.3.1.16/String.js";
import { ProgramModule_mkProgram, ProgramModule_withSubscription, ProgramModule_run } from "./.fable/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactSynchronous } from "./.fable/Fable.Elmish.React.3.0.1/react.fs.js";
import { view } from "./View.js";

export function scopeSub(position_0, position_1, dispatch) {
    dispatch(new Message(15, [position_0, position_1], dispatch));
}

export function fixScopes(_arg1) {
    const model = _arg1;
    return new Model(map((_arg3, arg10$0040) => mapScope_1((_arg2) => {
        const scope = _arg2;
        const canvasOption = scope.canvas;
        if (canvasOption == null) {
            return scope;
        }
        else {
            return new ScopeState(scope.analyser, scope.frameDuration, scope.offset, scope.range, fixCanvas(canvasOption), scope.timeDomainData);
        }
    }, arg10$0040), model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition);
}

export function addScope(position_0, position_1, dispatch, model) {
    const position = [position_0, position_1];
    return new Model(add(position, initScope(model.audioContext, position[0], position[1], dispatch), model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition);
}

export function addModule(position_0, position_1, name, model) {
    let matchValue;
    return new Model((matchValue = build(name, model.audioContext), (matchValue == null) ? model.mods : add([position_0, position_1], matchValue, model.mods)), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, void 0);
}

export function connectCable(_arg2, _arg1) {
    const cable = _arg2;
    const model = _arg1;
    return new Model(model.mods, model.jackRefs, add(cable.dest, cable, model.cables), void 0, model.loading, model.audioContext, model.addMenuPosition);
}

export function connectCmd(cable, _arg1) {
    return Cmd_OfFunc_perform(connect(cable), _arg1.mods, (cable_1) => (new Message(10, [true, cable_1])));
}

export function Sub_animate(dispatch) {
    const frame = (previous, current) => {
        const current_1 = current * 1;
        dispatch(new Message(11, current_1 - previous));
        void window.requestAnimationFrame(partialApply(1, frame, [current_1]));
    };
    void window.requestAnimationFrame(partialApply(1, frame, [0]));
}

export function Sub_listenForMIDI(dispatch) {
    const listenToInput = (input) => {
        let value_1;
        const matchValue = input.connection;
        switch (matchValue) {
            case "pending": {
                value_1 = (void 0);
                break;
            }
            case "closed": {
                value_1 = (void input.open().then((_arg1) => {
                    listenToInput(input);
                }));
                break;
            }
            default: {
                value_1 = (void 0);
            }
        }
        input.onmidimessage = ((message) => {
            dispatch(new Message(12, message.data));
        });
    };
    void requestMIDIAccess(singleton(new MIDIOption(0, false))).then((access) => {
        iterate(listenToInput, access.inputs.values());
    });
}

export function initProgram(audioContext, _arg1) {
    return [new Model(empty(), empty(), empty(), void 0, new LoadingState(2), audioContext, void 0), loadCmd];
}

export function minmaxBy(a, b, fn) {
    if (compare(fn(a), fn(b)) <= 0) {
        return [a, b];
    }
    else {
        return [b, a];
    }
}

export function inListsOf(count) {
    const recur = (row_mut, items_mut) => {
        recur:
        while (true) {
            const row = row_mut, items = items_mut;
            if (length(row) === count) {
                return cons(row, recur(empty_1(), items));
            }
            else if (isEmpty(items)) {
                if (isEmpty(row)) {
                    return empty_1();
                }
                else {
                    return singleton(row);
                }
            }
            else {
                row_mut = cons(head(items), row);
                items_mut = tail(items);
                continue recur;
            }
            break;
        }
    };
    return (arg) => map_1((list) => reverse(list), recur(empty_1(), arg));
}

export function newCable(stopJackId_0, stopJackId_1, _arg1) {
    const stopJackId = [stopJackId_0, stopJackId_1];
    const model = _arg1;
    return map_2((tupledArg) => (new Cable(tupledArg[0], tupledArg[1], nextId(model.cables))), bind((_arg2) => {
        const startJackId = _arg2.start[0];
        return bind((stopJack) => bind((startJack) => validateJackPair(startJackId, startJack, stopJackId, stopJack, model), getJack(startJackId[0], startJackId[1], model)), getJack(stopJackId[0], stopJackId[1], model));
    }, model.newCable));
}

export function startNewCable(jackId_0, jackId_1, model) {
    const jackId = [jackId_0, jackId_1];
    return defaultArg(map_2((el) => {
        const rect = el.getBoundingClientRect();
        return new Model(model.mods, model.jackRefs, model.cables, new NewCable([jackId, rect], middle(rect)), model.loading, model.audioContext, model.addMenuPosition);
    }, tryFind(jackId, model.jackRefs)), model);
}

export function removeCable(_arg2, _arg1) {
    const model = _arg1;
    return new Model(model.mods, model.jackRefs, remove(_arg2.dest, model.cables), model.newCable, model.loading, model.audioContext, model.addMenuPosition);
}

export function removeModule(position_0, position_1, model) {
    const position = [position_0, position_1];
    const patternInput = fold(uncurry(3, (tupledArg) => {
        const model_1 = tupledArg[0];
        const removedCables = tupledArg[1];
        return (tupledArg_1) => ((_arg1) => {
            const cable = _arg1;
            return (equalArrays(position, tupledArg_1[0]) ? true : equalArrays(position, cable.src[0])) ? [removeCable(cable, model_1), cons(cable, removedCables)] : [model_1, removedCables];
        });
    }), [model, empty_1()], model.cables);
    const model_2 = patternInput[0];
    return [new Model(remove(position, model_2.mods), filter((tupledArg_2, _arg1_1) => (!equalArrays(tupledArg_2[0], position)), model_2.jackRefs), model_2.cables, model_2.newCable, model_2.loading, model_2.audioContext, model_2.addMenuPosition), patternInput[1]];
}

export function disconnectCmd(cable, _arg1) {
    return Cmd_OfFunc_perform(disconnect(cable), _arg1.mods, (cable_1) => (new Message(10, [false, cable_1])));
}

export function resumeCtx(audioContext) {
    if (audioContext.state === "suspended") {
        void audioContext.resume();
    }
}

export function update(message, model) {
    let tupledArg;
    if (message.tag === 9) {
        return [fixScopes(model), Cmd_none()];
    }
    else if (message.tag === 0) {
        return [new Model(model.mods, model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, message.fields[0]), Cmd_none()];
    }
    else if (message.tag === 5) {
        return [new Model(model.mods, model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, void 0), Cmd_none()];
    }
    else if (message.tag === 6) {
        return [removeCable(message.fields[0], model), disconnectCmd(message.fields[0], model)];
    }
    else if (message.tag === 3) {
        return [startNewCable(message.fields[0][0], message.fields[0][1], model), Cmd_none()];
    }
    else if (message.tag === 4) {
        const matchValue = newCable(message.fields[0][0], message.fields[0][1], model);
        if (matchValue == null) {
            return [model, Cmd_none()];
        }
        else {
            const cable_1 = matchValue;
            resumeCtx(model.audioContext);
            return [connectCable(cable_1, model), connectCmd(cable_1, model)];
        }
    }
    else if (message.tag === 8) {
        return [new Model(model.mods, model.jackRefs, model.cables, void 0, model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 7) {
        return [new Model(model.mods, model.jackRefs, model.cables, map_2((newCable_2) => (new NewCable(newCable_2.start, message.fields[0])), model.newCable), model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 1) {
        const patternInput = removeModule(message.fields[0][0], message.fields[0][1], model);
        const model_1 = patternInput[0];
        return [model_1, Cmd_batch(map_1((cable_2) => disconnectCmd(cable_2, model_1), patternInput[1]))];
    }
    else if (message.tag === 2) {
        if (message.fields[1] === "scope") {
            return [model, Cmd_ofSub((tupledArg = message.fields[0], (dispatch) => {
                scopeSub(tupledArg[0], tupledArg[1], dispatch);
            }))];
        }
        else {
            const model_2 = addModule(message.fields[0][0], message.fields[0][1], message.fields[1], model);
            return [model_2, saveCmd(model_2)];
        }
    }
    else if (message.tag === 14) {
        resumeCtx(model.audioContext);
        const model_3 = new Model(control(message.fields[0])(model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition);
        return [model_3, saveCmd(model_3)];
    }
    else if (message.tag === 12) {
        return [new Model(midi(message.fields[0])(model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 15) {
        const model_4 = addScope(message.fields[0][0], message.fields[0][1], message.fields[1], model);
        return [model_4, saveCmd(model_4)];
    }
    else if (message.tag === 17) {
        return [new Model(change_2(message.fields[0], (option) => map_2((arg10$0040) => mapScope_1((scope) => (new ScopeState(scope.analyser, scope.frameDuration, scope.offset, scope.range, fixCanvas(message.fields[1]), scope.timeDomainData)), arg10$0040), option), model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 18) {
        return [new Model(model.mods, add(message.fields[0], message.fields[1], model.jackRefs), model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 16) {
        return [new Model(change_2(message.fields[0], (option_1) => map_2((arg10$0040_1) => mapScope_1((scope_1) => tick(model.audioContext.sampleRate * 1, new ScopeState(scope_1.analyser, scope_1.frameDuration, scope_1.offset, scope_1.range, scope_1.canvas, append(scope_1.timeDomainData, message.fields[1], Float32Array))), arg10$0040_1), option_1), model.mods), model.jackRefs, model.cables, model.newCable, model.loading, model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else if (message.tag === 10) {
        let cmd;
        const matchValue_1 = getJack(message.fields[0][1].src[0], message.fields[0][1].src[1], model);
        let pattern_matching_result;
        if (matchValue_1 != null) {
            if ((matchValue_1.label === "MIDI") ? message.fields[0][0] : false) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                cmd = Cmd_ofSub((dispatch_2) => {
                    Sub_listenForMIDI(dispatch_2);
                });
                break;
            }
            case 1: {
                cmd = Cmd_none();
                break;
            }
        }
        return [model, Cmd_batch(ofArray([saveCmd(model), cmd]))];
    }
    else if (message.tag === 20) {
        return [new Model(model.mods, model.jackRefs, model.cables, model.newCable, message.fields[0], model.audioContext, model.addMenuPosition), Cmd_none()];
    }
    else {
        toConsole(printf("unhandled: %A"))(message);
        return [model, Cmd_none()];
    }
}

export function run(mountAtId, context) {
    ProgramModule_run(Program_withReactSynchronous(mountAtId, ProgramModule_withSubscription((_arg1) => Cmd_ofSub((dispatch) => {
        document.defaultView.addEventListener("resize", (_arg2) => {
            dispatch(new Message(9));
        });
    }), ProgramModule_mkProgram(() => initProgram(context, void 0), (message, model) => update(message, model), (model_1, dispatch_1) => view(model_1, dispatch_1)))));
}

